import client from "./client";

export const previewNotice = async (target) =>
  (await client.post("/company/notify/preview", target)).data;
export const sendNotice = async (body) =>
  (await client.post("/company/notify/send", body)).data;
export const historyNotices = async () =>
  (await client.get("/company/notify/history")).data;
